import { useModalStateContext } from "../../../../contexts/ModalStateContext"
import DialogIncluirCooperado from "../../../../screens/Cadastros/components/MIPublicos/DialogIncluirCooperado"

export default function ModaisCadastros() {

    const { modais, handleToggleModal } = useModalStateContext()

    return (
        <>
            {
                modais.cadastros.incluirCooperado &&
                <DialogIncluirCooperado
                    open={modais.cadastros.incluirCooperado}
                    handleClose={() => handleToggleModal("cadastros", "incluirCooperado", false)}
                />
            }
        </>
    )
}
